import React from 'react';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import { plusPad } from '../../utilities/stringUtilities';
import { colors } from '../../style';

const StyledText = styled(Typography)({
  color: '#888787',
  lineHeight: 1.3,
});

const StyledLink = styled('a')({
  color: 'inherit',
  textDecoration: 'none',
});

export function formatCityStateZip(city?: string, state?: string, zip?: string): string {
  if (!city || !state) return '';
  return `${city}, ${state} ${zip || ''}`.trim();
}

function formatAddress(address1: string, address2?: string): string {
  if (!address2) return address1.trim();
  return `${address1.trim()} ${address2.trim()}`;
}

export function getGoogleMapsLink(
  name = '',
  address = '',
  city = '',
  state = '',
  zip = ''
): string {
  const baseUrl = 'https://www.google.com/maps/search/?api=1&query=';
  const a = plusPad(name);
  const b = plusPad(address);
  const c = plusPad(city);
  const d = plusPad(`${state} ${zip}`);
  const formattedAddress = [a, b, c, d].filter(s => s).join(',+');
  return formattedAddress ? `${baseUrl}${formattedAddress}`.toLowerCase() : '';
}

type Props = {
  name: string;
  address1: string;
  address2?: string;
  city: string;
  state: string;
  zip: string;
};

export default function ProviderAddress({
  name,
  address1,
  address2,
  city,
  state,
  zip,
}: Props): JSX.Element {
  const address = formatAddress(address1, address2);
  const href = getGoogleMapsLink(name, address, city, state, zip);

  const linkContent = (
    <StyledText variant="body2">
      {address},&nbsp;{formatCityStateZip(city, state, zip)}
    </StyledText>
  );

  if (!href) return linkContent;
  return (
    <StyledLink href={href} aria-label="provider address" target="_blank" rel="noopener noreferrer">
      {linkContent}
    </StyledLink>
  );
}
